/* eslint-disable camelcase, no-fallthrough */

import { LogLevel } from '@azure/msal-browser';
import { loadState } from '../utils/localStorage';

// MSAL configuration
export const getMsalConfig = (config) => {
  const flowFromState = loadState('flow', 'STRING');
  const flow = flowFromState ? config?.azure_ad_b2c?.[`${flowFromState}`] : config?.azure_ad_b2c?.clinician_flow;
  return ({
    auth: {
      clientId: config?.azure_ad_b2c?.clientId ?? '',
      authority:
        config?.azure_ad_b2c?.authority && config?.azure_ad_b2c?.tenantName
          ? `https://${config?.azure_ad_b2c?.authority}/${config?.azure_ad_b2c?.tenantName}/${flow}`
          : '',
      knownAuthorities: config?.azure_ad_b2c?.authority ? [config?.azure_ad_b2c?.authority] : [],
      redirectUri: `${window.location.origin}/`,
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);

            default:
          }
        },
      },
    },
  });
};

export const isBrowser = () => typeof window !== 'undefined';

export const clearCookies = () => {
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
  });
};

export const clearSession = () => {
  if (isBrowser()) {
    clearCookies();
    sessionStorage.clear();
    localStorage.clear();
  }
};
